import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-fdeef58a")

_pushScopeId("data-v-fdeef58a")
const _hoisted_1 = { class: "relative" }
const _hoisted_2 = { class: "justify-between" }
const _hoisted_3 = { class: "relative aspect-w-3 aspect-h-2" }
const _hoisted_4 = {
  class: "absolute grid bottom-0 right-0 py-4 px-2 m-4 text-gray-50 rounded-3xl gap-4",
  style: {"backdrop-filter":"blur(20px) brightness(0.75)"}
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" })
], -1)
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  class: "w-6 h-6"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 6.878V6a2.25 2.25 0 012.25-2.25h7.5A2.25 2.25 0 0118 6v.878m-12 0c.235-.083.487-.128.75-.128h10.5c.263 0 .515.045.75.128m-12 0A2.25 2.25 0 004.5 9v.878m13.5-3A2.25 2.25 0 0119.5 9v.878m0 0a2.246 2.246 0 00-.75-.128H5.25c-.263 0-.515.045-.75.128m15 0A2.25 2.25 0 0121 12v6a2.25 2.25 0 01-2.25 2.25H5.25A2.25 2.25 0 013 18v-6c0-.98.626-1.813 1.5-2.122"
  })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text-2xs" }, "view", -1)
const _hoisted_11 = { class: "dropdown dropdown-top" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", {
  tabindex: "0",
  class: "text-center"
}, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "stroke-width": "1.5",
    stroke: "currentColor",
    class: "w-6 h-6"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
    })
  ]),
  /*#__PURE__*/_createVNode("span", { class: "text-2xs text-center" }, "info")
], -1)
const _hoisted_13 = {
  tabindex: "0",
  class: "card compact right-0 dropdown-content shadow bg-base-100 dark:bg-gray-900 rounded-3xl w-64"
}
const _hoisted_14 = { class: "card-body text-gray-800 dark:text-gray-400" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h2", { class: "card-title" }, "Quote Insights", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "subpixel-antialiased" }
const _hoisted_18 = { class: "text-md" }
const _hoisted_19 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_20 = { class: "italic text-sm" }
const _hoisted_21 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_23 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    class: ['p-5 flex flex-wrap ' + _ctx.centerCard ? 'items-center justify-center': '']
  }, [
    _createVNode("div", {
      class: ['flex-shrink-0 mb-4 md:m-4 dark:bg-gray-900 relative overflow-hidden bg-white rounded-3xl shadow-lg ' + _ctx.cardWidth + ' ' + _ctx.mobileCardWidth]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              alt: _ctx.altImageText,
              src: _ctx.detailImage,
              loading: "lazy",
              class: "object-cover w-full h-auto md:max-w-sm"
            }, null, 8, ["alt", "src"]),
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _withDirectives(_createVNode("div", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.like && _ctx.like(...args)))
                }, [
                  _hoisted_6
                ], 512), [
                  [_vShow, !_ctx.isLike]
                ]),
                _withDirectives(_createVNode("div", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unLike && _ctx.unLike(...args))),
                  class: {'hidden': !_ctx.isLike, '': _ctx.isLike}
                }, [
                  _hoisted_7
                ], 2), [
                  [_vShow, _ctx.isLike]
                ]),
                _createVNode("div", _hoisted_8, [
                  _withDirectives(_createVNode("span", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.like && _ctx.like(...args))),
                    class: "text-2xs"
                  }, _toDisplayString(_ctx.likeCount), 513), [
                    [_vShow, !_ctx.isLike]
                  ]),
                  _withDirectives(_createVNode("span", {
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.unLike && _ctx.unLike(...args))),
                    class: [{'hidden': !_ctx.isLike, '': _ctx.isLike}, "text-2xs"]
                  }, _toDisplayString(_ctx.likeCount), 3), [
                    [_vShow, _ctx.isLike]
                  ])
                ])
              ]),
              (_ctx.showViewButton)
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: '/detail/'+_ctx.boostpackReference
                  }, {
                    default: _withId(() => [
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode("div", _hoisted_13, [
                  _createVNode("div", _hoisted_14, [
                    _hoisted_15,
                    (_ctx.boostpackItemData)
                      ? (_openBlock(), _createBlock("div", _hoisted_16, [
                          _createVNode("p", _hoisted_17, [
                            _createVNode("span", _hoisted_18, _toDisplayString(_ctx.boostpackItemData.title), 1),
                            _hoisted_19,
                            _createVNode("span", _hoisted_20, _toDisplayString(_ctx.boostpackItemData.description), 1),
                            _hoisted_21,
                            _createTextVNode(" " + _toDisplayString(_ctx.boostpackItemData.publication), 1),
                            _hoisted_22
                          ])
                        ]))
                      : (_openBlock(), _createBlock("div", _hoisted_23, " Unfortunately, we do not have any information about this Quote! "))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], 2)
  ], 2))
})